import { JwtPayload } from "jwt-decode"

export interface participant {
  firstName: string,
  lastName: string,
  phoneNum: string,
  licenseNumber: string,
  licenseExpiryDate: string,
  pistolType: string,
  pistolNumber: string,
  caliber: string,
  notes: string,
  email: string,
  isPaid?: boolean,
  adminNotes?: [{ id: number, content: string }],
  uniqueId?: string,
  isActive?: boolean
  paymentConfirmation?: string,
  createdAt: string,
}

export interface limitedWorkoutInterface {
  date: string,
  time: string,
  instructor: InstructorInterface,
  location: string,
  type: WorkoutTypesInterface,
  notes?: string | null,
  terms: string
  link: string
}

export interface workoutDetailsInterface {
  id?: number
  date: string,
  time: string,
  instructorId: string,
  instructor?: InstructorInterface,
  location: string,
  typeId: string,
  type?: WorkoutTypesInterface,
  maximumParticipants: number,
  participantsList?: participant[],
  currentParticipantsCount?: number,
  notes: string | null
  terms: string | null
  fullForm: boolean,
  isActive: boolean,
  price: number,
}

export interface userInterface {
  username: string,
  first_name: string,
  last_name: string,
  email: string,
  is_active?: boolean,
  last_login?: string,
  password?: string,
  phone_num: string,
  is_superuser?: boolean,
  mfa_enabled?: boolean,
}

export interface InstructorInterface {
  id: string,
  fullName: string,
  phoneNumber: string
}

export interface WorkoutTypesInterface {
  id: string,
  name: string
}

export interface MyCustomTokenPayload extends JwtPayload {
  user_id: number;
  email: string;
  name: string;
  mfa: boolean;
  isSU: boolean;
}

export interface ParticipantDirectoryInterface {
  id: number,
  phone_number: string,
  first_name: string,
  last_name: string,
  email: string,
  total_registrations: number,
  first_registered_at: string,
  last_registered_at: string,
  admin_notes: {"id":number,"content":string}[],
  workouts_list:{'id':number, 'date':string, 'time':string, 'type':string}[]
}

export const server = process.env.NODE_ENV === 'production' ? '/api/' : '/';

export const loginModalStyle = {
  position: 'fixed',
  minHeight: '40dvh',
  overflow: 'auto',
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  zIndex: 999,
};

export const editModalStyle = {
  position: 'fixed',
  height: '40dvh',
  overflow: 'auto',
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export const changeDateFormat = (date: string) => {
  var myDate = new Date(date);
  return `${myDate.getDate()}/${myDate.getMonth() as number + 1}/${myDate.getFullYear()}`;
}

export const calibers = ['9X19', '0.22', '9X17', '0.45', '0.40', '0.38', '0.357', "אחר"]

export const tableDesign = { width: '90dvw', minwidth: '60dvw', overflow: 'hidden', justifySelf: 'center' }
